// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"ac85e2f2","92":"522a24e9","181":"8bb39610","270":"777aa6f3","564":"fdb8e199","833":"97e5d12a","868":"ed5a2fad"}[chunkId] + ".chunk.js";
};